// Page Meta
// ----------------------------------------------------------
export const PAGES = {
  error: {
    title: 'エラーが発生しました'
  },
  home: {
    title: ''
  },
  detail: {
    title: '商品詳細'
  },
  Error404: {
    title: 'ページが見つかりませんでした',
    title_en: 'NOT FOUND.'
  }
};
